export const bannersConstants = {
 
    ADD_BANNERS_REQUEST: 'ADD_BANNERS_REQUEST',
    ADD_BANNERS_SUCCESS: 'ADD_BANNERS_SUCCESS',
    ADD_BANNERS_FAILURE: 'ADD_BANNERS_FAILURE',
    FETCH_STATE_REQUEST: 'FETCH_STATE_REQUEST',
    FETCH_STATE_SUCCESS: 'FETCH_STATE_SUCCESS',
    FETCH_STATE_FAILURE: 'FETCH_STATE_FAILURE',
    FETCH_BANNERS_REQUEST: 'FETCH_BANNERS_REQUEST',
    FETCH_BANNERS_SUCCESS: 'FETCH_BANNERS_SUCCESS',
    FETCH_BANNERS_FAILURE: 'FETCH_BANNERS_FAILURE',
    DELETE_BANNERS_REQUEST: 'DELETE_BANNERS_REQUEST',
    DELETE_BANNERS_SUCCESS: 'DELETE_BANNERS_SUCCESS',
    DELETE_BANNERS_FAILURE: 'DELETE_BANNERS_FAILURE',
    GET_BANNERS_DETAILS_REQUEST: 'GET_BANNERS_DETAILS_REQUEST',
    GET_BANNERS_DETAILS_SUCCESS: 'GET_BANNERS_DETAILS_SUCCESS',
    GET_BANNERS_DETAILS_FAILURE:'GET_BANNERS_DETAILS_FAILURE',
    UPDATE_BANNERS_REQUEST:'UPDATE_BANNERS_REQUEST',
    UPDATE_BANNERS_SUCCESS:'UPDATE_BANNERS_SUCCESS',
    UPDATE_BANNERS_FAILURE:'UPDATE_BANNERS_FAILURE',
    FETCH_SITELIST_REQUEST:'FETCH_SITELIST_REQUEST',
    FETCH_SITELIST_SUCCESS:'FETCH_SITELIST_SUCCESS',
    FETCH_SITELIST_FAILURE:'FETCH_SITELIST_FAILURE'       
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/bannersConstants.js